import React from "react";
import "./GoogleReviews.scss";
import googleReviewIcon from "./images/google-review.svg";

const googlePlaceId = "ChIJe_2SeABDXz4R3-AQv2KrUzI";
const googleMapsHref = `https://www.google.com/maps/search/?api=1&query=Shawarma%20Dose%20DXB&query_place_id=${googlePlaceId}`;
const googleReviewHref = `https://search.google.com/local/writereview?placeid=${googlePlaceId}`;

function GoogleReviews() {
  return (
    <section className="google-reviews" aria-labelledby="google-reviews-title">
      <div className="google-reviews__inner">
        <div className="google-reviews__summary">
          <img
            className="google-reviews__icon"
            src={googleReviewIcon}
            alt=""
            aria-hidden="true"
          />
          <div>
            <p className="google-reviews__eyebrow">Google Reviews</p>
            <h2 id="google-reviews-title">Loved by Shawarma Fans in Dubai</h2>
          </div>
        </div>

        <div className="google-reviews__rating" aria-label="Rated 4.5 out of 5 on Google">
          <strong>4.5</strong>
          <div className="google-reviews__stars" aria-hidden="true">
            {[1, 2, 3, 4].map((star) => (
              <span key={star} className="google-reviews__star is-full">
                ★
              </span>
            ))}
            <span className="google-reviews__star is-half">★</span>
          </div>
          <span>Google rating</span>
        </div>

        <div className="google-reviews__actions">
          <a href={googleMapsHref} target="_blank" rel="noopener noreferrer">
            Read Google Reviews
          </a>
          <a
            className="google-reviews__actions-secondary"
            href={googleReviewHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            Rate us on Google
          </a>
        </div>
      </div>
    </section>
  );
}

export default GoogleReviews;
